import { useEffect, useState } from "react";
import { fetchPastorDistricts } from "../api/pastorDistricts";
import type { PastorDistrictDto } from "../types/city";

export function usePastorDistricts(): PastorDistrictDto[] | null {
  const [districts, setDistricts] = useState<PastorDistrictDto[] | null>(null);

  useEffect(() => {
    let cancelled = false;

    fetchPastorDistricts()
      .then((items) => {
        if (!cancelled) setDistricts(items);
      })
      .catch(() => {
        if (!cancelled) setDistricts([]);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return districts;
}
